"use client";
import { DataLayerGA4AttrType } from "@packages/lib/types/datalayerGA";
import { GA4DataLayerFn } from "@packages/lib/utlils/helper-function";
import Image from "next/image";
import Getprospectus from "@packages/shared-components/common-utilities/cards/interaction-button/getprospectus";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import { ClickstreamConstants } from "@packages/shared-components/services/constants";
import { GA_VALUES } from "@packages/constants/ga.const";
interface LeafBannerProps {
  title: string;
  bgColor: string;
  desc: string;
  buttonName: string;
  bannerSrc: string;
  hrefValue?: string;
  btnId?: any;
  commonGAAttrs?: any;
  btnSection?: any;
  enquiryDetails?: any;
  CSCommonData?: any;
  uniInfo?: any;
  commonOldGAAttrs?:any
}

const LeafBanner = ({
  title,
  bgColor,
  desc,
  buttonName,
  bannerSrc,
  hrefValue,
  btnId,
  commonGAAttrs,
  btnSection,
  enquiryDetails,
  CSCommonData,
  uniInfo,
  commonOldGAAttrs
}: LeafBannerProps) => {

  const handleCtaClick = () => {  
    if (hrefValue) {
      window.location.href = hrefValue;
      return;
    }
    if (btnId) {
      const target = document.getElementById(String(btnId));
      target?.click();
    }
  };

  const handleGALogs = (): DataLayerGA4AttrType => {
    return {
      event: "ga_events",
      eventName: GA_VALUES.events.bannerCTAClicks,
      ...commonGAAttrs,
      cta_url: hrefValue || "NA",
      cta_name: buttonName || "NA",
    };
  };

  const CSData = (): ClickstreamInterface => {
    return {
      ...CSCommonData,
      actionType: ClickstreamConstants.clickAction,
    };
  };

  return (
    <div className="px-[16px] md:px-[20px] lg:px-0">
      <div
        className={`${bgColor} p-[16px] md:py-[0] gap-[20px] md:gap-[0]  md:px-[20px] rounded-[8px] flex md:flex-row flex-col-reverse justify-between items-end !m-0`}
      >
        <div className="flex flex-col gap-[16px] py-[0] md:py-[24px] !m-0">
          <div className="text-grey300 flex flex-col gap-[4px]">
            <div className="h4 heading4 font-semibold font-farro">{title}</div>
            <div className="font-inter font-normal small">{desc}</div>
          </div>
          {btnId === "gp-btn" ? <Getprospectus
            enquiryProps={{
              subOrderItemId: enquiryDetails?.subOrderItemId,
              orderItemId: enquiryDetails?.orderItemId,
              collegeId: uniInfo?.institutionId,
              qualCode: "",
              collegeName: uniInfo?.institutionTextKey,
              collegeDisplayName: uniInfo?.institutionName,
              csPageName:
                typeof window !== "undefined" &&
                  localStorage.getItem("gaPageName")
                  ? localStorage.getItem("gaPageName")
                  : "institutionpage",
              pageName: "contenthub",
              sectionName : btnSection,
              ...CSData,
            }}
            commonGAAttrs={commonGAAttrs}
            btnSize={"xl:btn-large xl:text-para w-full md:!w-auto"}
            leafbtn={true}
            commonOldGAAttrs={commonOldGAAttrs}
          /> :
            <button
              type="button"
              onClick={() => {
                handleCtaClick();
                GA4DataLayerFn(handleGALogs());
              }}
              className="flex gap-[6px] items-center btn btn-primary rtfcustom-link hover:no-underline px-[20px] py-[10px] w-fit !no-underline"
            >
              {buttonName}
              <svg
                width="16"
                height="14"
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.55556 1.55554L15 6.99999M15 6.99999L9.55555 12.4444M15 6.99999L1 6.99999"
                  stroke="#fff"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          }
        </div>
        <span className="md:min-w-[219px] w-full md:w-auto flex justify-center !m-0">
          <Image width="219" height="166" alt="banner" src={bannerSrc} />
        </span>
      </div>
    </div>
  );
};

export default LeafBanner;
